export { EcotrapContent } from "./ecotrap-content";
